import { render, staticRenderFns } from "./NewBeneficiaryPage.vue?vue&type=template&id=63cae0ec&scoped=true&"
import script from "./NewBeneficiaryPage.vue?vue&type=script&lang=js&"
export * from "./NewBeneficiaryPage.vue?vue&type=script&lang=js&"
import style0 from "./NewBeneficiaryPage.vue?vue&type=style&index=0&id=63cae0ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cae0ec",
  null
  
)

export default component.exports